<div class="school-class-mini-preview">
  <a [routerLink]="classPath" class="school-class-mini-preview__top">
    <div class="school-class-mini-preview__logo">
      <brt-game-organization-logo [name]="schoolClassData.classNumber + ' ' + schoolClassData.classAddition"></brt-game-organization-logo>
    </div>

    <div class="school-class-mini-preview__top-stats">
      <div class="school-class-mini-preview__position-wrapper">
        {{currentRank}}. Platz
      </div>

      <div class="school-class-mini-preview__activity">
<!--        <brt-level-icon [level]="activityLevel"></brt-level-icon>-->
<!--        <brt-level-activity-label [level]="activityLevel"></brt-level-activity-label>-->
      </div>
    </div>

    <div class="school-class-mini-preview__item-actions" brtItemActions [items]="menuItems">
      <brt-icon [icon]="'dotting'"></brt-icon>
    </div>
  </a>

  <div class="school-class-mini-preview__bottom">
    <div class="school-class-mini-preview__graph-preview">
      <brt-chart [data]="chartData"></brt-chart>
    </div>

    <div class="school-class-mini-preview__points-wrapper">
      <div class="school-class-mini-preview__points-label">Punkte</div>
      <div class="school-class-mini-preview__points-value">{{currentPoints | number:'.'}}</div>
    </div>
  </div>
</div>
